<template>
    <div 
    class="form-group" 
    :class="formGroupClass">

        <form-label 
        v-if="label" 
        :class="labelClass"
        :for="id"
        v-html="$sanitize(label)" />

        <table class="table table-grid table-shrink w-100">
            <thead>
                <th></th>
                <th
                v-for="column in columns"
                class="text-center">
                    {{column}}
                </th>
            </thead>
            <tbody>

                <tr v-for="(row_value, row_key) in rows">

                    <td width="100">
                        {{row_value}}
                    </td>

                    <td 
                    v-for="(column_value, column_key) in columns"
                    width="20" 
                    class="text-center">

                        <label 
                        v-if="type == 'radio'"
                        :for="id+'-'+row_key+'-'+column_key" 
                        class="custom-checkbox">
                            <checkbox 
                            @change="checked => change(row_key, checked, column_key)"
                            :checked="$_.get(value, row_key) == column_key"
                            :value="column_key" />
                        </label>

                        <label 
                        v-if="type == 'checkbox'"
                        :for="id+'-'+row_key+'-'+column_key" 
                        class="custom-checkbox">
                            <checkbox 
                            @change="checked => change(row_key, checked, column_key)"
                            :checked="$_.get(value, row_key, []).includes(column_key)"
                            :value="column_key" />
                        </label>

                    </td>

                </tr>
            </tbody>
        </table>

        <form-errors v-bind="{errors}" />
		
    </div>
</template>

<script>

    import { mapState } from 'vuex'

    export default {

        inheritAttrs: false,

        props: {
            id: {
                type: String,
                default() {
                    return `input-radio-${this._uid}`
                },
            },

            labelClass: {
                type: String,
                default: ''
            },

            type: {
                type: String,
                default: 'radio'
            },

            columns: {
                type: Object,
                default: () => {}
            },

            rows: {
                type: Object,
                default: () => {}
            },

            options: {
                type: Array,
                default: () => []
            },

            formGroupClass: {
                type: [String, Array],
                default: ''
            },
			
            errors: {
                type: String,
                default: "",
            },

            value: [String, Number, Boolean, Array, Object],
            label: String,
            sublabel: String

        },

        methods: {

            change(key, checked, value) {

                var output = _.cloneDeep(this.value)
                    output = _.isObject(output) ? output : {}

                if(this.type == 'radio')
                {
                    if(checked) {
                        output[key] = value
                    } else {
                        delete output[key]
                    }   
                }

                if(this.type == 'checkbox')
                {
                    if(checked) {

                        output[key] = _.isArray(output[key])
                        ? _.concat(output[key], value)
                        : [value]

                    } else {
                        output[key] = _.pull(output[key], value)
                    }

                    if(!output[key].length)
                    {
                        delete output[key];
                    }
                }

                this.$emit('input', output)
            }

        }

    }
</script>
